export class MineducSendParams {
    start: string;
    finish: string;
    courseId: string;
    month:number;
}